// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__9O3ap","active":"PopoverSharedStyle_active__yB5pj","backdrop":"PopoverSharedStyle_backdrop__LLVGk"};